import Banner from "../blocks/Banner"
import Info from "../blocks/Info"
import LogoRow from "../blocks/LogoRow"
import Footer from "../blocks/Footer"

const Landing = () => {
  return (
    <div>
      <Banner/>
      <Info/>
      <LogoRow/>
      <Footer/>
    </div>
  )
}

export default Landing